// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c8611316","239":"69890d77","453":"b27fe1b7","455":"e093b9ac"}[chunkId] + ".chunk.js";
};